import { PriceDisplayMode } from './priceDisplayMode.models';

export interface PriceDisplayModeState {
  ids: string[];
  entities: Record<string, PriceDisplayMode>;
  currentAccountingId: string | null;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_PRICE_DISPLAY_MODES' }
  | {
      type: 'FETCH_PRICE_DISPLAY_MODES_SUCCESS';
      payload: { priceDisplayModes: PriceDisplayMode[] };
    }
  | { type: 'FETCH_PRICE_DISPLAY_MODES_FAILURE'; payload: { error: string } }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: PriceDisplayModeState = {
  ids: [],
  entities: {},
  currentAccountingId: null,
  isLoading: true,
  isLoaded: false,
  error: null,
};

export const priceDisplayModeReducer = (
  state: PriceDisplayModeState,
  action: Action
): PriceDisplayModeState => {
  switch (action.type) {
    case 'FETCH_PRICE_DISPLAY_MODES':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.ids.length,
        error: null,
      };
    case 'FETCH_PRICE_DISPLAY_MODES_SUCCESS': {
      const firstMode = action.payload.priceDisplayModes[0];
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        currentAccountingId: firstMode?.accountingId || null,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.priceDisplayModes.map((i) => i.accountingId),
          ]),
        ],
        entities: action.payload.priceDisplayModes.reduce(
          (prev, curr) => ({
            ...prev,
            [curr.accountingId]: curr,
          }),
          state.entities
        ),
      };
    }
    case 'FETCH_PRICE_DISPLAY_MODES_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
